import React from "react";

const PurchaseModal = ({ }) => {
    
    return (
        <>
            <div
                className={`modal fade show purchase-modal`}
                tabIndex="-1"
            >
                <div className="modal-dialog">
                    {/* <div className="modal-content">
                        <div className="modal-header mb-0">
                            <h5 className="modal-title">Purchase Agreement</h5>

                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                            // onClick={handleModalCancel}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-4">
                                <p className="mb0 sky-text">Please review the purchase terms and sign to confirm your purchase.</p>
                            </div>

                            <div className="sky-bg mb-4">
                                <h6>
                                    Auction details
                                </h6>
                                <table>
                                    <tr>
                                        <td>
                                            Lot Number
                                        </td>
                                        <td>
                                            PROP-2026-0142
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Auction Date
                                        </td>
                                        <td>
                                            January 19, 2026
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Item Description
                                        </td>
                                        <td>
                                            Luxury Villa in Al-Rabwa District
                                        </td>
                                    </tr>
                                </table>
                            </div>

                            <div className="sky-bg mb-4">
                                <h6>
                                    Final price calculation
                                </h6>
                                <table>
                                    <tr>
                                        <td>
                                            Buyer’s premium
                                        </td>
                                        <td>
                                            D 3,200
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Seller commission
                                        </td>
                                        <td>
                                            D 1,500
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Platform fees
                                        </td>
                                        <td>
                                            D 500
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Taxes
                                        </td>
                                        <td>
                                            D 50
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="black-text">
                                            <strong>Total</strong>
                                        </td>
                                        <td>
                                            <strong>D 6,200</strong>
                                        </td>
                                    </tr>
                                </table>
                            </div>

                            <div className="sky-bg mb-4">
                                <h6>
                                    Terms and Conditions
                                </h6>
                                <div className="scroll">
                                    <p>
                                        By signing this Purchase Agreement, you acknowledge and agree to:
                                    </p>
                                    <ul>
                                        <li>
                                            Payment of the total amount shown above within 5 business days
                                        </li>
                                        <li>
                                            Collection or shipping arrangements to be made within 14 days
                                        </li>
                                        <li>
                                            All sales are final and non-refundable except as required by law
                                        </li>
                                        <li>
                                            The item is sold "as is" with no warranties unless explicitly stated
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="mb-3">
                                <label htmlFor="" className="pb5">Digital Signature *</label>
                                <input type="text" className="form-control" placeholder="Type your full name" />
                            </div>
                            <p className="sky-text">
                                By typing your name, you agree that this constitutes a legal signature.
                            </p>
                            <div className="mb-3">
                                <input type="checkbox" className="css-checkbox" id="agreement" />
                                <label htmlFor="agreement" className="css-label">I have read and agree to the terms and conditions of this Purchase Agreement</label>
                            </div>

                        </div>
                        <div className="d-flex">
                            <button
                                className="btn btn-sky btn-md width50"
                            // onClick={handleModalCancel}
                            >
                                Cancel
                            </button>
                            <button
                                className="btn btn-primary btn-md width50"
                            // onClick={handleModalConfirm}
                            >
                                Sign & Submit
                            </button>
                        </div>
                    </div> */}
{/* 
                    <div className="modal-content">
                        <div className="modal-header mb-0">
                            <h5 className="modal-title">Confirm Forfeiture</h5>

                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                            // onClick={handleModalCancel}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-4">
                                <p className="mb0 sky-text">You are about to forfeit your winning bid. This action cannot be undone.</p>
                            </div>

                            <div className="alert alert-red mb-3">
                                Forfeiting your purchase will result in financial penalties and may affect your ability to bid in future auctions.
                            </div>

                            <div className="sky-bg mb-4">
                                <h6>
                                    Applicable Penalties
                                </h6>
                                <table>
                                    <tr>
                                        <td>
                                            Forfeit Fee (15% of Hammer Price)
                                        </td>
                                        <td>
                                            D 3,200
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="pb10">
                                            Non-Refundable Deposit Loss
                                        </td>
                                        <td>
                                            D 1,500
                                        </td>
                                    </tr>
                                    <tr className="bdr-t pt-10">
                                        <td className="black-text pt10">
                                            <strong>Total Penalty Amount</strong>
                                        </td>
                                        <td>
                                            <strong>D 6,200</strong>
                                        </td>
                                    </tr>
                                </table>
                            </div>

                            <div className="sky-bg mb-4">
                                <h6>
                                    Additional Consequences:
                                </h6>
                                <div className="scroll">
                                    <ul>
                                        <li>
                                            Your deposit of €1,000.00 will not be refunded
                                        </li>
                                        <li>
                                            You will be billed for the 15% forfeit fee within 5 business days
                                        </li>
                                        <li>
                                            Your bidding privileges may be suspended pending payment
                                        </li>
                                        <li>
                                            This forfeiture will be recorded in your account history
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="mb-3">
                                <input type="checkbox" className="css-checkbox" id="agreement" />
                                <label htmlFor="agreement" className="css-label">I understand and confirm forfeiture, accepting all penalties and consequences listed above</label>
                            </div>

                        </div>
                        <div className="d-flex">
                            <button
                                className="btn btn-sky btn-md width50"
                            // onClick={handleModalCancel}
                            >
                                Cancel
                            </button>
                            <button
                                className="btn btn-red btn-md width50"
                            // onClick={handleModalConfirm}
                            >
                                Confirm Forfeiture
                            </button>
                        </div>
                    </div> */}

                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="text-center">
                                <p>
                                    <img src="/img/check-L.svg" alt="" />
                                </p>
                                <h4>
                                    Purchase Confirmed!
                                </h4>
                                <div className="mb-4">
                                    <p className="sky-text">
                                        Your purchase agreement has been successfully submitted and processed.
                                    </p>
                                </div>
                            </div>
                            <div className="sky-bg mb-4">
                                <h6>
                                    Confirmation Email Sent
                                </h6>
                                <p>
                                    A receipt and payment instructions have been sent to your registered email address.
                                </p>
                            </div>

                            <div className="sky-bg">
                                <h6>
                                    Next Steps:
                                </h6>
                                <div className="scroll">
                                    <ul>
                                        <li>
                                            Complete payment within 5 business days
                                        </li>
                                        <li>
                                            Arrange collection or shipping within 14 days
                                        </li>
                                        <li>
                                            Check your email for detailed instructions
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex">
                            <button
                                className="btn btn-white btn-md btn-full"
                                type="button"
                                data-bs-dismiss="modal"
                            // onClick={handleModalCancel}
                            >
                                Close
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
};

export default PurchaseModal;
